export type VideoStatusType =
  | 'UPLOADING'
  | 'UPLOAD_FAILED'
  | 'ENCODING'
  | 'ENCODING_FAILED'
  | 'PROCESSING'
  | 'READY'
  | 'FAILED';

const VideoStatus: Readonly<Record<VideoStatusType, VideoStatusType>> = {
  UPLOADING: 'UPLOADING',
  UPLOAD_FAILED: 'UPLOAD_FAILED',
  ENCODING: 'ENCODING',
  ENCODING_FAILED: 'ENCODING_FAILED',
  PROCESSING: 'PROCESSING',
  READY: 'READY',
  FAILED: 'FAILED',
};

/**
 * These numeric values are returned by the web app API, and we need to map them to our own
 * VideoStatus values
 */
const WebAppVideoStatusToVideoStatus = {
  0: VideoStatus.ENCODING,
  1: VideoStatus.READY,
  2: VideoStatus.ENCODING_FAILED,
};

export { VideoStatus, WebAppVideoStatusToVideoStatus };
